

define(['jquery', 'angular', 'uiRouter'], function ($, angular) {

    angular.module('tracking.directive', ['ui.router']).directive('trackSubmit', function ($state, $rootScope) {
        return {
            restrict: 'AE',
            link: function link($scope, element, attr) {
                element.on('mousedown', function (event) {
                    var transition = attr && attr.trackSubmit;

                    var trackSubmit = {
                        currentRoute: $state.current,
                        transition: transition,
                        errors: []
                    };
                    angular.forEach($('input.ng-invalid, select.ng-invalid'), function (el) {
                        var modelName = $(el).attr('ng-model');
                        var errorText = $(el).attr('data-error-text');
                        trackSubmit.errors.push({
                            fieldName: modelName ? modelName : 'no-model',
                            errorMessage: errorText ? errorText : // eslint-disable-line no-nested-ternary
                            $(el).has('required') ? 'required' : 'no error text'
                        });
                    });

                    $rootScope.$broadcast('trackSubmit', trackSubmit);
                });
            }
        };
    }).directive('trackLink', function ($state, $rootScope) {
        return {
            restrict: 'AE',
            link: function link($scope, element, attr) {
                element.on('mousedown', function (event) {

                    var state = attr && attr.trackLink;

                    if (state) {
                        var trackLink = {
                            currentRoute: $state.current,
                            transition: state
                        };
                        $rootScope.$broadcast('trackLink', trackLink);
                    }
                });
            }
        };
    }).directive('trackInput', function ($state, $rootScope) {
        /*
         * Track an input tag with track-input attribute
         * you can use the value of track-input attribute as
         * a tracking attr Eg.: track-input="xo_guest_yes"
         */
        return {
            restrict: 'AE',
            link: function link($scope, element, attr) {
                element.on('click', function (event) {

                    var state;

                    if (event.target.type === 'checkbox') {
                        if (event.target.checked) {
                            state = attr && attr.trackInput + '_CHECKED';
                        } else {
                            state = attr && attr.trackInput + '_UNCHECKED';
                        }
                    } else {
                        state = attr && attr.trackInput;
                    }

                    var trackInput = {
                        currentRoute: $state.current,
                        page: 'main:ec:hermes::fullpage-billing:guest:aries:'
                    };

                    if (state) {
                        trackInput.transition = state;
                    }

                    $rootScope.$broadcast('trackInput', trackInput);
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-tracking/dist/directive.js
 ** module id = 170
 ** module chunks = 1
 **/